var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.field && _vm.field.caption)?_c('legend',[_vm._v(_vm._s(_vm.field.caption))]):_vm._e(),_c('app-form',{attrs:{"model":_vm.field.value,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }